<div id="overlay" *ngIf="currentContentComponent != null" data-cy="ModalDialog_Overlay" interactive="-1"
  (interact)="closeFromOutsideDialog($event)">

  <div class="modal-window" #modal tabindex="-1">
    <div class="main {{ config.customClass }}">
      <div class="modal-header">
        <h3>{{ config.title | translate }}</h3>
        <button class="icon close-modal" data-cy="ModalDialog_Button_X" (click)="dismiss()">
          <typeface-icon>close</typeface-icon>
        </button>
      </div>
      <ng-container *ngComponentOutlet="currentContentComponent; inputs: config.contentInputs"></ng-container>
      <div class="footer">
         @if (config.withReturnValue) {
          <button data-cy="ModalDialog_Button_Cancel" (click)="dismiss()">
            {{ config.cancelLabel | translate }}
          </button>
          <button class="primary" data-cy="ModalDialog_Button_Accept" (click)="accept()">
            {{ config.acceptLabel | translate }}
          </button>
        } @else {
          <button class="primary" data-cy="ModalDialog_Button_Close" (click)="dismiss()">
            {{ config.dismissLabel | translate }}
          </button>
        }
      </div>
    </div>
  </div>

</div>
